import React, { useState } from "react";
import { Check } from "lucide-react";
import { AUDIENCES, audienceAccent } from "@/lib/postAudience";
import { CloseFriendsLink, CloseFriendsDialog } from "@/components/CloseFriends";

// Lot 649 — liste « Qui peut voir ta publication ? » partagée par le composeur (verre sombre) et le menu d'une publication (clair).
// Lot 655 — sous « Amis proches » (sélectionné), lien « Gérer la liste » : `onManageCloseFriends` (feuille sombre de l'éditeur de story)
// ou, par défaut, le dialog clair interne.
const rowDark = "w-full flex items-center gap-3 px-3 py-3 rounded-2xl text-left text-sm font-semibold bg-white/5 active:bg-white/15 transition-colors";
const rowLight = "w-full flex items-center gap-3 px-3 py-3 rounded-2xl text-left text-sm font-semibold hover:bg-black/5 active:bg-black/10 transition-colors";

export const AudienceOptions = ({ value, onPick, t, tone = "dark", busy = false, onManageCloseFriends }) => {
  const [manageOpen, setManageOpen] = useState(false);
  const manage = onManageCloseFriends || (() => setManageOpen(true));
  return (
    <div className="space-y-1.5 mt-1" data-testid="post-audience-options" data-value={value}>
      {AUDIENCES.map((a) => {
        const on = value === a.key;
        const accent = audienceAccent(a.key);
        return (
          <React.Fragment key={a.key}>
            <button type="button" disabled={busy} onClick={() => onPick(a.key)} className={tone === "dark" ? rowDark : rowLight} aria-pressed={on} data-testid={`post-audience-${a.key}`}>
              <span className="h-9 w-9 rounded-full grid place-items-center shrink-0" style={{ background: on ? accent : (tone === "dark" ? "rgba(255,255,255,0.12)" : "var(--yalola-surface-alt)"), color: on ? "#fff" : (a.accent || "inherit") }}><a.icon size={17} /></span>
              <span className="flex-1 min-w-0"><span className="block truncate">{t(a.tkey, a.label)}</span><span className="block text-[11px] font-normal opacity-60 truncate">{t(a.dkey, a.desc)}</span></span>
              {on && <Check size={18} style={{ color: accent }} />}
            </button>
            {a.key === "close_friends" && on && <div className="pl-3 pb-1" data-testid="post-audience-close-friends-manage"><CloseFriendsLink onClick={manage} tone={tone} testId="audience-close-friends-link" /></div>}
          </React.Fragment>
        );
      })}
      {!onManageCloseFriends && <CloseFriendsDialog open={manageOpen} onOpenChange={setManageOpen} />}
    </div>
  );
};

export default AudienceOptions;
